/**
 * @Description 客流计数 - 任务详情抽屉顶部
 */

import { FC, useContext, useEffect, useMemo, useState } from 'react';
import { globalAlias } from '@/common/utils/ways';
import { useMethods } from '@lhb/hook';
import { getRelativeChancePoint, relateToChancePoint } from '@/common/api/passengerflowcount';
import styles from './index.module.less';
import { Carousel, Image } from 'antd';
import { beautifyThePrice, isArray } from '@lhb/func';
import dayjs from 'dayjs';

import UserInfoContext from '@/layout/context';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import UncorrelatedChancePoint from './UncorrelatedChancePoint';
import CorrelatedChancePoint from './CorrelatedChancePoint';
import SelectChancePointTemplate from '@/common/components/business/ExpandStore/SelectChancePointTemplate';
import ChancePointDetail from '@/common/components/business/ExpandStore/ChancePointDetail';
import RelativePointMatching from './RelativePointMatching';

const SpotDetailDrawerTop: FC<{
  detail: any;
  ableToChangepoint?: boolean; // 是否展示机会点操作
}> = ({ detail, ableToChangepoint = true }) => {
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息
  const [selectTemplateVisible, setSelectTemplateVisible] = useState<boolean>(false); // 选择机会点模板
  const [chancepointTemplateData, setChancepointTemplateData] = useState<any>({ // 机会点模板数据
    isLoaded: false,
    data: [],
  });
  const [formDrawerData, setFormDrawerData] = useState<any>({ // 机会点表单抽屉
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
  });
  const [relativePointOpen, setRelativePointOpen] = useState<{visible:boolean, detail:any}>({ visible: false, detail: null });
  const [relativeChancePoints, setRelativeChancePoints] = useState<any>([]); // 已关联的机会点列表
  const [pointId, setPointId] = useState<any>(0); // 机会点id
  const [detailVisible, setDetailVisible] = useState<boolean>(false); // 详情抽屉是否可见

  const chancepointAlias = useMemo(() => {
    return globalAlias(globalAliasItemVOs);
  }, [globalAliasItemVOs]);
  const assignedData = useMemo(() => {
    const {
      lng,
      lat,
      address,
      poi,
      pictures,
      name
    } = detail;
    const params: any[] = [];
    if (+lng && +lat && address) {
      const basicAddress = {
        identification: 'basicAddress',
        textValue: JSON.stringify({
          address,
          longitude: lng,
          latitude: lat,
          poiName: address
        })
      };
      params.push(basicAddress);
    }
    if (poi) {
      const basicChancePointName = {
        identification: 'basicChancePointName',
        textValue: name
      };
      params.push(basicChancePointName);
    }
    if (isArray(pictures) && pictures.length) {
      const basicProjectPhotos = {
        identification: 'basicProjectPhotos',
        textValue: JSON.stringify(pictures)
      };
      params.push(basicProjectPhotos);
    }
    return params;
  }, [detail]);

  useEffect(() => {
    if (detail?.id) {
      methods.getRelativeChancePointHandle();
    }
  }, [detail?.id]);

  const methods = useMethods({
    // 创建机会点
    createChancePoint: () => {
      const { isLoaded, data } = chancepointTemplateData;
      if (!isLoaded) return; // 接口未加载完
      if (!data.length) { // 没有模版
        V2Message.warning(`未配置机会点模板`);
      }
      // 只有一个模板时直接创建
      if (data.length === 1 && data[0]?.value) {
        setFormDrawerData({
          templateId: data[0].value,
          open: true,
        });
        return;
      }
      setSelectTemplateVisible(true);
    },
    updateHandle: (chancepointId: number | number[]) => { // 机会点创建成功
      // 调用关联接口
      const params = {
        id: detail?.id,
        chancePointIds: isArray(chancepointId) ? chancepointId : [chancepointId]
      };
      relateToChancePoint(params).then(() => {
        methods.getRelativeChancePointHandle();
      });
    },
    relativeChancePoint() {
      setRelativePointOpen({
        ...relativePointOpen,
        visible: true,
        detail: detail,
      });
    },
    getRelativeChancePointHandle() {
      getRelativeChancePoint({ id: detail?.id }).then((res: any) => {
        setRelativeChancePoints(res);
      });
    },
    getDateFormat(date) {
      const daysOfWeek = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const dayOfWeek = new Date(date).getDay();
      return daysOfWeek[dayOfWeek];
    },
  });
  return (
    <div className={styles.topContainer}>
      <div className={styles.imagesWrap}>
        { detail.pictures?.length ? (
          <Image.PreviewGroup >
            <Carousel autoplay infinite={false}>
              { detail.pictures?.map((item: any, index: number) => {
                return <Image key={index} width={300} height={240} src={item.url} />;
              }) }
            </Carousel>
          </Image.PreviewGroup>
        ) : <img className={styles.imagesEmpty} src='https://staticres.linhuiba.com/project-custom/locationpc/flow/empty_bg@2x.png' /> }
      </div>
      <div className={styles.rightContainer}>
        <div className={styles.headerTitle}>{ detail.name }</div>
        <div className={styles.address}>{ detail.poi }<img src='https://staticres.linhuiba.com/project-custom/locationpc/flow/map_icon@2x.png' onClick={() => {
          window.open(`https://www.amap.com/regeo?lng=${detail.lng}&lat=${detail.lat}`);
        }}/></div>
        <div className={styles.flowCountWeek}>
          {detail?.tasks?.length && detail.tasks.map((item) => {
            return (
              <div className={styles.countWeekItem} key={item.id}>
                <div className={styles.weekInfo}>{ `${dayjs(item.date).format('MM.DD')}(${methods.getDateFormat(item.date)})` }</div>
                <div className={styles.countInfo}>{ item.anaStatus === 3 ? <><span>{ beautifyThePrice(item.flow, ',', 0) }</span>人</> : '-' }</div>
              </div>
            );
          })}
        </div>
        {/* <div className={styles.recordPointInfoWrap}>
          <div className={styles.infoTitle}>记录点位信息<span className={styles.subTitle}>可记录工程、房东、租金、周边等信息</span></div>
          <div className={styles.comingSoonWrap}>
            <div className={styles.comingSoonText}>功能开发中，敬请期待...</div>
            <img className={styles.comingSoonImg} src='https://staticres.linhuiba.com/project-custom/locationpc/flow/developer_icon@2x.png' />
          </div>
        </div> */}
        { !relativeChancePoints?.length ? (
          <UncorrelatedChancePoint
            chancepointAlias={chancepointAlias}
            createChancePoint={methods.createChancePoint}
            relativeChancePoint={methods.relativeChancePoint}
            ableToChangepoint={ableToChangepoint}
          />
        ) : <CorrelatedChancePoint
          chancepointAlias={chancepointAlias}
          relativeChancePoints={relativeChancePoints}
          createChancePoint={methods.createChancePoint}
          relativeChancePoint={methods.relativeChancePoint}
          setPointId={setPointId}
          setDetailVisible={setDetailVisible}
          ableToChangepoint={ableToChangepoint}
        /> }
      </div>

      {/* 新建机会点时的模版选择框  */}
      <SelectChancePointTemplate
        setVisible={setSelectTemplateVisible}
        open={selectTemplateVisible}
        chancepointAlias={chancepointAlias}
        setFormDrawerData={setFormDrawerData}
        setTemplateData={setChancepointTemplateData}
      />
      {/* 机会点详情和表单创建抽屉  */}
      <ChancePointDetail
        pointId={pointId}
        chancepointAlias={chancepointAlias}
        assignedData={assignedData}
        formDrawerData={formDrawerData}
        setFormDrawerData={setFormDrawerData}
        detailVisible={detailVisible}
        setDetailVisible={setDetailVisible}
        // refreshDetail={refreshDetail}
        // onSearch={() => setFilters({})}
        onSearch={methods.updateHandle}
      />
      <RelativePointMatching
        id={detail?.id}
        data={relativePointOpen}
        setData={setRelativePointOpen}
        chancepointAlias={chancepointAlias}
        refresh={methods.getRelativeChancePointHandle}
      />
    </div>
  );
};

export default SpotDetailDrawerTop;
